<template>
  <div class="war-room-profile-hints">
    <BravadoText class="war-room-profile-hints__element" tag="h4" variant="headline-semibold">
      Interact as you feel comfortable
    </BravadoText>
    <BravadoText class="war-room-profile-hints__element" tag="p" variant="subhead">
      We believe that an honest discussion is essential for the community. Switch between the best identity for each
      situation.
    </BravadoText>
    <ul class="war-room-profile-hints__list">
      <li>
        <BravadoText class="war-room-profile-hints__element" tag="p" variant="body-semibold">
          Avoid associating it to your real name
        </BravadoText>
      </li>
      <li><BravadoText tag="p" variant="body-semibold">Avoid using a photo of yourself as your avatar</BravadoText></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WarRoomProfileHints',
};
</script>

<style lang="scss" scoped>
.war-room-profile-hints {
  box-shadow: var(--theme-elevation-01);
  width: 100%;
  background-color: var(--theme-color-highlight);
  border-radius: 8px;
  padding: 16px;
  border: 1px solid var(--universal-color-gold);
  color: var(--theme-color-text);

  &__list {
    padding-left: 16px;
  }

  &__element {
    margin-bottom: 8px;
  }
}
</style>
